import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { IStudentFlexibleRate } from '.';

export type TAdminCreateStudentFlexibleRate = {
  package: string;
  amounts: Array<{
    studentFlexibleRateVersion: string;
    amount: number;
    currency: string;
  }>;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TAdminGetStudentFlexibleRates = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  packageId?: string;
  country?: string;
  curriculum?: string;
  grade?: string;
  userId?: string;
};

export type TAdminUpdateStudentFlexibleRate = {
  id: string;
  package: string;
  amounts: Array<{
    studentFlexibleRateVersion: string;
    amount: number;
    currency: string;
  }>;
  country?: string;
  curriculum?: string;
  grade?: string;
};

export type TGetUserFlexibleRates = {
  userId: string;
  curriculum?: string;
  grade?: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetStudentFlexibleRatesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  packageId,
  country,
  curriculum,
  grade,
}: TAdminGetStudentFlexibleRates) => {
  let path = `${AdminApiPaths.adminStudentFlexibleRates}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (packageId) {
    path += `&packageId=${packageId}`;
  }

  if (country) {
    path += `&country=${country}`;
  }

  if (curriculum) {
    path += `&curriculum=${curriculum}`;
  }

  if (grade) {
    path += `&grade=${grade}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IStudentFlexibleRate>>
  >(path);

  return response.data;
};

export const adminCreateStudentFlexibleRate = createAsyncThunk(
  '/admin/student-flexible-rates/create',
  async (data: TAdminCreateStudentFlexibleRate) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRates}`;

    const response = await apiDataProvider.post<
      TApiResponse<IStudentFlexibleRate>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateStudentFlexibleRate = createAsyncThunk(
  '/admin/student-flexible-rates/update',
  async (data: TAdminUpdateStudentFlexibleRate) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRates}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IStudentFlexibleRate>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteStudentFlexibleRate = createAsyncThunk(
  '/admin/student-flexible-rates/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRates}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IStudentFlexibleRate>
    >(path);

    return response.data;
  }
);

export const getUserFlexibleRatesAsAdmin = createAsyncThunk(
  '/admin/flexible-plan-rates/user/list',
  async ({ userId, curriculum, grade }: TGetUserFlexibleRates) => {
    let path = `${AdminApiPaths.adminStudentFlexibleRates}/user/${userId}?userId=${userId}`;

    if (curriculum) {
      path += `&curriculum=${curriculum}`;
    }

    if (grade) {
      path += `&grade=${grade}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<IStudentFlexibleRate[]>
    >(path);

    return response.data;
  }
);

export const adminGetStudentFlexibleRates = createAsyncThunk(
  '/admin/student-flexible-rates/list',
  adminGetStudentFlexibleRatesModule
);
